import React, { useEffect, useState } from "react";
import { Gift, Loader2, CheckCircle2 } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { fmt0 } from "../lib/format";
import { toast } from "sonner";

export default function DailyBonus() {
  const { user, refreshWallet } = useAuth();
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = () => {
    if (!user) return;
    api.get("/daily-bonus/status").then((r) => setStatus(r.data)).catch(() => {});
  };

  useEffect(() => { load(); }, [user]); // eslint-disable-line

  if (!user || !status) return null;

  const claim = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/daily-bonus/claim");
      toast.success(`🎁 Daily bonus ${fmt0(data.amount)} added!`);
      refreshWallet();
      load();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
      load();
    } finally { setLoading(false); }
  };

  return (
    <div className="rl-card p-3.5 flex items-center gap-3 rl-gold-border" data-testid="daily-bonus-card"
      style={{ background: "linear-gradient(120deg,#FEF3C7,#FFFFFF)" }}>
      <div className="w-11 h-11 rounded-xl rl-gold-bg flex items-center justify-center shrink-0"><Gift className="w-6 h-6" /></div>
      <div className="flex-1">
        <div className="font-display font-bold text-slate-900 text-sm">Daily Login Bonus{status.welcome && <span className="ml-1.5 text-[9px] font-black px-1.5 py-0.5 rounded-full bg-emerald-600 text-white align-middle" data-testid="daily-bonus-welcome-badge">WELCOME · நாள் {status.welcome.step_day}/{status.welcome.total_days}</span>}</div>
        <div className="text-[11px] text-slate-500">{status.available ? <>Claim <b className="text-slate-900">{fmt0(status.amount)}</b> free to your wallet today!{status.welcome && <span className="text-emerald-700"> · நாளை {fmt0(status.welcome.next_amount)}</span>}</> : status.budget_exhausted && status.last_date !== new Date(Date.now() + 5.5 * 3600000).toISOString().slice(0, 10) ? <span data-testid="daily-bonus-budget-over">{status.window_closed ? "Daily bonus இந்த நேரத்தில் இல்லை · பிறகு வாங்க" : "இன்றைய bonus முடிந்தது · நாளை மீண்டும் வாங்க"}</span> : <>Claimed today · come back tomorrow{status.welcome && <span className="text-emerald-700"> · நாளை {fmt0(status.amount)}</span>}</>}</div>
      </div>
      {status.available ? (
        <button onClick={claim} disabled={loading} className="rl-gold-bg font-bold text-xs px-4 py-2 rounded-full flex items-center gap-1 shrink-0" data-testid="daily-bonus-claim-btn">
          {loading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : "CLAIM"}
        </button>
      ) : (
        <CheckCircle2 className="w-6 h-6 text-emerald-400 shrink-0" data-testid="daily-bonus-claimed" />
      )}
    </div>
  );
}
